module.exports = __webpack_public_path__ + "static/양념소스-6b3f6a1cac1cf43f0105b0bf7a901cd4.jpg";